module.exports = __webpack_public_path__ + "img/emb.67c1e0db.png";